import React from 'react';
import styled from '@emotion/styled';
import { mqMin } from 'utils/responsive';
import { TopHeader } from 'ui/components/panes/Header/TopHeader';
import { TopFooter } from 'ui/components/panes/Footer/TopFooter';
import { TERMS_OF_SERVICE } from 'domain/valueObjects/Terms/Terms';

const Container = styled.div`
    width: 87.674%;
    max-width: 1400px;
    margin: 60px auto;
    color: #333;
    line-height: 1.8;

    ${mqMin('NARROW')} {
        width: 92.014%;
    }
`;

const Title = styled.h2`
    font-size: 1.875rem;
    font-weight: bold;
    margin-bottom: 40px;
    border-left: 5px solid var(--blue);
    padding-left: 15px;
`;

const Section = styled.div`
    margin-bottom: 40px;
`;

const SubHeading = styled.h3`
    font-size: 1.25rem;
    margin-top: 30px;
    margin-bottom: 10px;
    font-weight: bold;
`;

const Paragraph = styled.p`
    margin: 10px 0;
`;

export const TermsOfService = () => {
    return (
        <>
            <TopHeader />
            <Container>
                <Title>{TERMS_OF_SERVICE.title}</Title>
                {TERMS_OF_SERVICE.sections.map((section, index) => (
                    <Section key={index}>
                        <SubHeading>{section.heading}</SubHeading>
                        <Paragraph>
                            {section.content.split('\n').map((line, lineIndex) => (
                                <React.Fragment key={lineIndex}>
                                    {line}
                                    {lineIndex < section.content.split('\n').length - 1 && <br />}
                                </React.Fragment>
                            ))}
                        </Paragraph>
                    </Section>
                ))}
            </Container>
            <TopFooter />
        </>
    );
};
